/**
 * Section 2: Property Access
 */

import { useCallback } from 'preact/hooks';
import { useForm } from '@ox/visits-ui/context/FormContext';
import { Input, Select, Textarea } from '@ox/visits-ui/components/shared/FormComponents';

export function Section2QCPropertyAccess() {
  const { formData, updateField } = useForm();

  const handleAccessChange = useCallback(
    (value: string) => updateField('were_able_to_access_property', value),
    [updateField],
  );

  const handleLockboxLocationChange = useCallback(
    (value: string) => updateField('lockbox_location', value),
    [updateField],
  );

  const handleWorkingCodesChange = useCallback(
    (value: string) => updateField('working_codes', value),
    [updateField],
  );

  const handleSquattersChange = useCallback(
    (value: string) => updateField('squatters', value),
    [updateField],
  );

  const handleSquattersDescriptionChange = useCallback(
    (value: string) => updateField('squatters_description', value),
    [updateField],
  );

  return (
    <div className="form-section">
      <h2>Property Access</h2>

      <p>
        <strong>Note:</strong> If you were unable to access the property, you'll be asked to
        describe the access issues in the next section.
      </p>

      <Select
        label="Were you able to gain access to the property?"
        name="were_able_to_access_property"
        value={formData.were_able_to_access_property || ''}
        onChange={handleAccessChange}
        options={[
          { label: 'Select...', value: '', disabled: true },
          { label: 'Yes', value: 'Yes' },
          { label: 'No', value: 'No' },
        ]}
        required
      />

      {formData.were_able_to_access_property === 'Yes' && (
        <>
          <Input
            label="Lockbox Location Description"
            name="lockbox_location"
            value={formData.lockbox_location || ''}
            onChange={handleLockboxLocationChange}
            placeholder="EX: Garage trim, Front Door, Hose bib"
            required
          />

          <Input
            label="Which access code or codes gave you access to the property?"
            name="working_codes"
            value={formData.working_codes || ''}
            onChange={handleWorkingCodesChange}
            placeholder="EX: 1234"
            required
          />

          <Select
            label="Is there any evidence of squatters, forced entry or additional security concerns such as lockbox damage?"
            name="squatters"
            value={formData.squatters || ''}
            onChange={handleSquattersChange}
            options={[
              { label: 'Select...', value: '', disabled: true },
              { label: 'Yes', value: 'Yes' },
              { label: 'No', value: 'No' },
            ]}
            required
          />
          {formData.squatters === 'Yes' && (<Textarea
            label="Please describe the security issue you encountered and whether it was able to be resolved during your visit"
            name="squatters_description"
            value={formData.squatters_description || ''}
            onChange={handleSquattersDescriptionChange}
            autoSize
            required
          />)}
        </>
      )}
    </div>
  );
}
